import { invoke } from '../../QTBridge';

const storageGroup = 'webMeeting';
export const popoStorage = {
  get(key: string) {
    return invoke('getStorage', {
      group: storageGroup,
      key,
    }).then((res) => {
      console.log('getStorage', res);
      return res?.data?.value;
    });
  },
  set(key: string, value: string) {
    console.log('setStorage', key, value);
    return invoke('setStorage', {
      group: storageGroup,
      key,
      value,
    });
  },
  remove(key: string | undefined) {
    return invoke('removeStorage', {
      group: storageGroup,
      key,
    });
  },
};
